import { TablePagination } from './TablePagination';
export default TablePagination;